import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_49564_30336)\"><circle cx=\"8.99997\" cy=\"8.99997\" r=\"7.36765\" fill=\"#F43F5E\" stroke=\"white\" stroke-width=\"1.5\"></circle><path d=\"M9 5.69116V9.66175\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"></path><circle cx=\"8.99999\" cy=\"12.7058\" r=\"0.558824\" fill=\"white\" stroke=\"white\"></circle></g><defs><clipPath id=\"clip0_49564_30336\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }